module.exports = fox => {
	'use strict';
	
	var _ = {
		getTranslation: function(alias) {
			var translation = {
				'emailNotValid': function() {return fox.i18n.getTranslation('emailNotValid', 'Email is not valid', 'tooltip');},
				'fieldNotEmpty': function() {return fox.i18n.getTranslation('fieldNotEmpty', 'Fields shouldn\'t be empty', 'tooltip');}
			};

			return translation[alias] || '';
		}
	};

	fox.registerWidget('Login_Wizard_ForgotForm', {
		configure: function() {
			this.registerOptions('', {
				template: 'login_verification_forgot_form_en',
				widgets: {
					forgotPassword: {
						widget: 'PasswordRecovery'
					},
					recaptcha: {
						widget: 'RecaptchaFox'
					},
					captchaApi: {
						widget: 'Api',
						method: 'passwordRecovery.sendRecoveryMail',
						httpMethod: 'post',
						encodePost: true
					},
					form: {
                        widget: 'DomForm',
                        formSelector: '#forgot-form',
                        elements: {
                            email: {
                                validators: [
                                    {
                                        validator: 'regexp',
                                        options: {type: 'email'},
                                        message: this.getTextMessage('emailNotValid')
                                    },
                                    (value) => {
                                        return {
                                            result: value.length > 0,
                                            message: this.getTextMessage('fieldNotEmpty')
                                        };
                                    }
                                ]
                            }
                        }
					},
				},
				handleWom: {
                    formInvaliadate: {
                        widget: '#form',
                        event: ['form_valid', 'form_not_valid'],
                        callback: this._handleFormValidation.bind(this)
					},
					
					sendRecoveryMail: {
						widget: '#forgotPassword',
						event: 'sendRecoveryMail',
						callback: 'answerSendRecoveryMail'
					}
				},
				handleDom: {
					formButtonSubmit: {
						target: '#send-forgot',
						callback: '_submit'
					},
					formSubmit: {
						target: '#forgot-form',
						event: 'submit',
						callback: '_submit'
					},
					cancel: {
						target: '#change-form-login',
						callback: '@parent:showLoginForm'
					},
					focus: {
						target: 'input[name="email"]',
						event: 'focus',
						callback: () => {
							$('.notice-container .txt p').text('');
							this.errorBox.hide();
						}
					}
				},
			});

			return this.callParent('configure', arguments);
		},

		_handleFormValidation(formData, form) {

            formData.forEach(resp => {
                var $elm = $(this.dom1(''.concat('[name="', resp.field, '"]'))).parent();

				if (resp.result === false) {
					this.showErrorMessage(resp.message, resp.field);
					$elm.addClass('error');

					return;
				}

				$elm.removeClass('error');

			});
		},

		showErrorMessage(message) {
			var errItem = $('.notice-container .txt p').text(message);
			this.errorsContainer.html('').append(errItem);
			this.errorBox.show();
		},

		rendering() {
            this.callParent('rendering', arguments);

			this.errorBox = $(this.dom('#errors'));
			this.errorsContainer = $(this.dom('#errors .txt'));
		},

		addedToDom() {
			this.callParent('addedToDom', arguments);
			this._recaptcha = this.wom1('#recaptcha');

			if (this._recaptcha.isNeed()) {
				this._recaptcha.load();
			}
		},

		_submit(el, w, alias, e) {
			fox.jQuery.Event(e).preventDefault();

            this.wom1('#form').submit().then(result => {
                if (result === false) {
					return;
				}

				this.togglePreloader(true);

				this.submit(result.email).catch(() => {
					this.togglePreloader(false);
				});
			});

			return false;
		},

		togglePreloader(state) {
			var btn = this.dom1('#send-forgot');

			if (!btn) {
				return;
			}

			fox.dom[(state ? 'addClass' : 'removeClass')]('spin', btn);
		},
		

		submit(email) {
			const input = fox.dom.selectFirst('#email-forgot', this.element);

			if (!this._recaptcha || !this._recaptcha.isNeed()) {
				this.wom1('#forgotPassword').sendRecoveryMail(email);
				input.readonly = true;
				input.parentNode.style.opacity = 0.5;
				return Promise.resolve();
			}

			return this._recaptcha.getToken('forgotpassword').then(captchaToken => {
				const data = { email };

				if (this._recaptcha.captchaVariant === 'invisible') {
					data['g-recaptcha-invisible-response'] = captchaToken || '';
				} else if (captchaToken) {
					data['g-recaptcha-response'] = captchaToken;
				} else {
					return Promise.reject(new Error('captcha empty'));
				}

				input.readonly = true;
				input.parentNode.style.opacity = 0.5;

				return this.wom1('#captchaApi').psend(data)
					.then(resp => {
						this.answerSendRecoveryMail(resp.params.answer.response);
					})
					.catch(err => {
						const answer = err.params ? err.params.answer : {};

						if (this._recaptcha.isNeed()) {
							this._recaptcha.load('onError');
						}

						input.readonly = false;
						input.parentNode.style.opacity = 1;

						this.answerSendRecoveryMail(answer.response || { text: answer.reason, success: false });
					});
			});
		},

		answerSendRecoveryMail(answer) {
			var infoForgotElm = fox.dom.selectFirst('#info-forgot', this.element);
			var input = fox.dom.selectFirst('#email-forgot', this.element);

			this.togglePreloader(false);

			infoForgotElm.parentElement.style.display = 'block';
			infoForgotElm.innerHTML = answer.text;

			input.readonly = false;
			input.parentNode.style.opacity = 1;
		},

		getTextMessage(alias) {
			return _.getTranslation(alias);
		}

	});
};


// WEBPACK FOOTER //
// ./components/login-wizard/widget/forgot-form.es.js